import React, { useContext } from 'react';
import { Route, ScrollToTop, Switch } from '@thd-olt-component-react/router';
import { string, number, shape } from 'prop-types';
import { AppContext } from '@thd-nucleus/app-render';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Error } from './pages';
import { getRoutes } from './routes';

export const App = ({
  pipTimeout,
  prefetchPip,
  productPodHoverDelay,
  data
}) => {
  const { instance } = useContext(AppContext);
  const {
    currentRouteName,
    currentRouteComponent
  } = instance.router;

  const routes = getRoutes(currentRouteName, currentRouteComponent);
  const { channel } = useContext(ExperienceContext);
  return (
    <>
      <ScrollToTop />
      <Switch>
        <Route path={routes.colorWall.path}>
          <routes.colorWall.component data={data} />
        </Route>

        <Route path={routes.browse.path}>
          {channel === 'mobile'
            ? (
              <routes.browseMobile.component
                pageType="browse"
                prefetchPip={prefetchPip}
                productPodHoverDelay={productPodHoverDelay}
              />
            )
            : (
              <routes.browse.component
                pageType="browse"
                prefetchPip={prefetchPip}
                productPodHoverDelay={productPodHoverDelay}
              />
            )}
        </Route>
        <Route path={routes.search.path}>
          {channel === 'mobile'
            ? (
              <routes.searchMobile.component
                pageType="search"
                prefetchPip={prefetchPip}
                productPodHoverDelay={productPodHoverDelay}
              />
            )
            : (
              <routes.search.component
                pageType="search"
                prefetchPip={prefetchPip}
                productPodHoverDelay={productPodHoverDelay}
              />
            )}
        </Route>
        <Route exact path={routes.product.path}>
          {channel === 'mobile' ? <routes.productMobile.component pipTimeout={pipTimeout} />
            : <routes.product.component pipTimeout={pipTimeout} />}
        </Route>
        <Route exact path={routes.compare.path}>
          <routes.compare.component />
        </Route>
        <Route exact path={routes.home.path}>
          <routes.home.component />
        </Route>
        <Route path="/error">
          <Error />
        </Route>
        <Route>
          <Error />
        </Route>
      </Switch>
    </>
  );
};

App.propTypes = {
  pipTimeout: string,
  prefetchPip: string,
  productPodHoverDelay: number,
  data: shape({})
};

App.defaultProps = {
  pipTimeout: null,
  prefetchPip: null,
  productPodHoverDelay: 500,
  data: null
};
